import { Record } from '../components/Dictation/components/Record'

export const DictationRecordPage = () => {
    return <Record />
}
